import { Promise } from '@ambita/ambita-components-core';
import { MappedAddress } from './realty';

declare global {
  interface Window { AMBITA_CONFIG: any; }
}

export interface OrganizationDataOverride {
  name: string;
  address: MappedAddress;
}

export interface Config {
  environment: string;
  organizationDataOverrides: {
    [key: string]: OrganizationDataOverride;
  };
}

let config: Config;

export function fetchConfig(): Promise<Config> {
  return new Promise((resolve) => {
    document.addEventListener('DOMContentLoaded', () => {
      config = window.AMBITA_CONFIG;
      resolve(config);
    });
  });
}

export function getConfig(): Config {
  if (!config) {
    throw Error('Could not read config');
  }

  return config;
}
